<template>
  <div class="app-container">
    <div class="card">
      <div class="title ta-c">报名中交易会 <span v-text="data.reporting"></span> 场</div>
      <div class="title ta-c">未读通知 <span v-text="data.unread"></span> 条</div>
      <div class="counts flex">
        <div class="count">
          <div class="label">待审核</div>
          <div class="number" v-text="data.auditing"></div>
        </div>
        <div class="count">
          <div class="label">已完成</div>
          <div class="number" v-text="data.completed"></div>
        </div>
        <div class="count">
          <div class="label">总报名</div>
          <div class="number" v-text="data.total"></div>
        </div>
      </div>
      <div class="infos">
        <p><van-icon style="color:red" name="notes-o" /><span class="link" @click="dialog.tip = true">保证金缴纳账号</span></p>
        <p><van-icon style="color:red" name="notes-o" /><a class="link" target="blank"
            href="/static/files/北京国家粮食交易中心交易报名系统用户使用手册.pdf">系统使用说明</a>
        </p>
      </div>
    </div>
    <van-dialog v-model="dialog.tip" title="保证金缴纳账号">
      <div class="tips-wrap">
        <p>保证金在竞价交易会前，须按照交易公告、细则规定时间，到达北京国家粮食交易中心账户，否则无法参与竞价交易会。参会单位的保证金，必须由本单位直接支付，不得由其他企业或个人垫付、代付。</p>
        <p>开户名称：北京国家粮食交易中心</p>
        <p>开户银行：工商银行广安门支行营业室</p>
        <p>开户银行账号：0200001909200023318</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
const dayjs = require('dayjs')
export default {
  data() {
    return {
      dayjs,
      data: {
        reporting: 0,
        auditing: 0,
        completed: 0,
        total: 0,
        unread: 0,
        recent: []
      },
      dialog: {
        tip: false
      }
    };
  },

  methods: {
    get_data() {
      this.$store
        .dispatch("dashboard/info")
        .then((res) => {
          Object.assign(this.data, res)
        })
        .catch(() => { });
    }
  },
  created() {
    this.get_data()
  }
};
</script>

<style lang="less" scoped>
.app-container {
  margin-top: -5%;
  padding: 0 5%;
  box-sizing: border-box;
}

.card {
  padding: 8% 2%;
  background: #fff;
  border-radius: 10px;
  box-shadow: rgba(#000, 0.1) 0 4px 5px;
  box-sizing: border-box;
}

.title {
  color: #505050;
  font-size: 1.2rem;
  margin-bottom: 4%;
}

.counts {
  margin-top: 10%;
  justify-content: space-around;

  .count {
    text-align: center;
    border-radius: 10px;
    padding: 3% 5%;
    color: #fff;

    .link {
      margin-top: 10%;
      font-size: 1.5em;
    }

    &:nth-child(1) {
      background: #5a55db;
    }

    &:nth-child(2) {
      background: #49b83a;
    }

    &:nth-child(3) {
      background: #e98a40;
    }
  }
}

.infos {
  margin-top: 10%;
  text-indent: 22%;
  color: #555;
  font-size: 1rem;

  .link {
    color: #555;
  }

  .van-icon {
    color: #4e20d8;
    margin-right: 5%;
  }
}

.counts {
  font-size: 0.8rem;
}

.tips-wrap {
  padding: 2% 4%;
  box-sizing: border-box;
  line-height: 1.7;
  p {
    font-size: 0.8rem;
  }
}
</style>
